export var TOCBUYORSELL;
(function (TOCBUYORSELL) {
    TOCBUYORSELL["BUY"] = "Buy";
    TOCBUYORSELL["SELL"] = "Sell";
    TOCBUYORSELL["SIP"] = "SIP";
    TOCBUYORSELL["GTT"] = "GTT";
})(TOCBUYORSELL || (TOCBUYORSELL = {}));
export var TOCOrderType;
(function (TOCOrderType) {
    TOCOrderType["MARKET"] = "MARKET";
    TOCOrderType["LIMIT"] = "LIMIT";
    TOCOrderType["SL"] = "SL";
})(TOCOrderType || (TOCOrderType = {}));
export var TOCProductCode;
(function (TOCProductCode) {
    TOCProductCode["CNC"] = "CNC";
    TOCProductCode["MIS"] = "MIS";
    TOCProductCode["NRML"] = "NRML";
    TOCProductCode["MTF"] = "MTF";
    TOCProductCode["BO"] = "BO";
})(TOCProductCode || (TOCProductCode = {}));
export var TOCValidationCode;
(function (TOCValidationCode) {
    TOCValidationCode["DAY"] = "DAY";
    TOCValidationCode["IOC"] = "IOC";
    TOCValidationCode["GTC"] = "GTC";
})(TOCValidationCode || (TOCValidationCode = {}));
export var EQTOCIgnoreList = ["CO", "GTC", "GTD", "STOP_MARKET"];
export var NCDTOCIgnoreList = [
    "CO",
    "GTC",
    "GTD",
    "MIS",
    "NRML",
    "MTF",
    "BO",
    "MARKET",
    "STOP_LIMIT",
    "STOP_MARKET",
];
export var ETFTOCIgnoreList = [
    "CO",
    "GTC",
    "GTD",
    "STOP_MARKET",
    "MIS",
    "MTF",
    "BO",
];
export var FNOTOCIgnoreList = [
    "CO",
    "MTF",
    "GTC",
    "GTD",
    "CNC",
    "STOP_MARKET",
];
export var COMMTOCIgnoreList = [
    "CO",
    "MTF",
    "BO",
    "GTC",
    "GTD",
    "CNC",
    "STOP_MARKET",
];
export var SIPIgnoreList = ["CO", "BO", "MTF", "GTC", "GTD", "MIS"];
export var CURRENCYIgnoreList = [
    "CO",
    "MTF",
    "GTC",
    "GTD",
    "CNC",
    "STOP_MARKET",
];
export var NCDIgnoreList = [
    "CO",
    "BO",
    "MTF",
    "GTC",
    "GTD",
    "NRML",
    "MIS",
    "STOP_LIMIT",
    "STOP_MARKET",
];
